@if (accountNotProvisioned()) {
  <app-account-not-provisioned
    [username]="oidcUsername() || userName"
    (goToPortal)="goToPortalSystem()"
    (logout)="logout()">
  </app-account-not-provisioned>
} @else if (isMobile()) {
  <app-admin-layout-mobile
    [sidebarOpen]="sidebarOpen()"
    [profileIncomplete]="profileIncomplete()"
    [canSeeDashboard]="canSeeDashboard()"
    [canSeeProfile]="canSeeProfile()"
    [canSeePurchaseSale]="canSeePurchaseSale()"
    [canSeeQrTrace]="canSeeQrTrace()"
    [canSeeChat]="canSeeChat()"
    [canSeeSurvey]="canSeeSurvey()"
    [canSeeObservations]="canSeeObservations()"
    [canSeeBusinessTypeSettings]="canSeeBusinessTypeSettings()"
    [tradeMenuActive]="tradeMenuActive()"
    [fullScreenRoute]="fullScreenRoute()"
    [fullMainRoute]="fullMainRoute()"
    [chatUnreadCount]="chatUnreadCount()"
    [pendingInvitationCount]="pendingInvitationCount()"
    [userName]="userName"
    [userEmail]="userEmail"
    [userRole]="userRole"
    [userAvatar]="userAvatar()"
    (toggleSidebar)="toggleSidebar()"
    (closeSidebar)="closeSidebar()"
    (logout)="logout()"
    (navigateToOidcAccountInfo)="navigateToOidcAccountInfo()"
    (goToPortalSystem)="goToPortalSystem()">
  </app-admin-layout-mobile>
} @else {
  <div class="admin-layout">
    <!-- Sidebar -->
    <aside id="app-sidebar" class="sidebar" [class.collapsed]="sidebarCollapsed()">
      <div class="sidebar-header">
        <a routerLink="/secure/admin" class="logo-link">
          <img src="/assets/images/logo2.png" alt="Logo" class="logo-img"/>
          <div class="logo-text-block">
            <span class="logo-title">ACFS Supply Chain</span>
          </div>
        </a>
      </div>

      <nav class="sidebar-nav">
        <a class="nav-item" [attr.title]="navTitle('กลับไปที่ e-Portal')" (click)="goToPortalSystem()">
          <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
          </svg>
          <span>กลับไปที่ e-Portal</span>
        </a>
        @if (canSeeDashboard()) {
          <a class="nav-item" [attr.title]="navTitle('หน้าหลัก')" routerLink="/admin/dashboard" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="3" width="7" height="7" rx="1"/>
              <rect x="14" y="14" width="7" height="7" rx="1"/>
              <rect x="3" y="14" width="7" height="7" rx="1"/>
            </svg>
            <span>หน้าหลัก</span>
          </a>
        }

        @if (canSeeProfile()) {
          <a class="nav-item" [attr.title]="navTitle('โปรไฟล์')" routerLink="/profile" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="8" r="4"/>
              <path d="M20 21a8 8 0 1 0-16 0"/>
            </svg>
            <span>โปรไฟล์</span>
          </a>
        }

        @if (canSeePurchaseSale() && !profileIncomplete()) {
          <a class="nav-item" [attr.title]="navTitle('บันทึกซื้อ-ขาย')" routerLink="/trade" [class.active]="tradeMenuActive()">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <span>บันทึกซื้อ-ขาย</span>
          </a>
        }

        @if (canSeeObservations() && !profileIncomplete()) {
          <a class="nav-item" [attr.title]="navTitle('รายงานข้อสังเกต')" routerLink="/trade/observations" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
              <line x1="12" y1="9" x2="12" y2="13"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>รายงานข้อสังเกต</span>
          </a>
        }

        @if (canSeeQrTrace() && !profileIncomplete()) {
          <a class="nav-item" [attr.title]="navTitle('ยืนยันการจำหน่าย (QR Trace)')" routerLink="/qr-trace-confirm" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 11l3 3L22 4"/>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
            </svg>
            <span>ยืนยันการจำหน่าย (QR Trace)</span>
          </a>
        }

        @if (canSeeChat() && !profileIncomplete()) {
          <a class="nav-item" [attr.title]="navTitle('แชท')" routerLink="/chat" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
            </svg>
            <span>แชท</span>
            @if (chatUnreadCount() > 0) {
              <span class="nav-badge-chat">{{ chatUnreadCount() }}</span>
            }
          </a>
        }

        @if (canSeeSurvey() && !profileIncomplete()) {
          <a class="nav-item" [attr.title]="navTitle('แบบสอบถาม')" routerLink="/survey" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>แบบสอบถาม</span>
          </a>
        }

        @if (canSeeBusinessTypeSettings() && !profileIncomplete()) {
          <div class="nav-section-label">ผู้ดูแลระบบ</div>
          <a class="nav-item" [attr.title]="navTitle('ตั้งค่าประเภทธุรกิจ')" routerLink="/admin/business-types" routerLinkActive="active">
            <svg class="nav-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                 stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="3"/>
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
            </svg>
            <span>ตั้งค่าประเภทธุรกิจ</span>
          </a>
        }
      </nav>

      <div class="sidebar-footer">
        <button type="button" class="btn-collapse" (click)="toggleSidebarCollapse()"
                [title]="sidebarCollapsed() ? 'ขยายเมนู' : 'ย่อเมนู'"
                [attr.aria-label]="sidebarCollapsed() ? 'ขยายเมนู' : 'ย่อเมนู'"
                [attr.aria-expanded]="!sidebarCollapsed()" aria-controls="app-sidebar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
        </button>
      </div>
    </aside>

    <!-- Main Content -->
    <div class="main-content">
      @if (!fullScreenRoute()) {
        <header class="topbar">
          <div class="topbar-left">
            <button type="button" class="hamburger-btn" (click)="toggleSidebarCollapse()"
                    [title]="sidebarCollapsed() ? 'ขยายเมนู' : 'ย่อเมนู'"
                    [attr.aria-label]="sidebarCollapsed() ? 'ขยายเมนู' : 'ย่อเมนู'"
                    [attr.aria-expanded]="!sidebarCollapsed()" aria-controls="app-sidebar">
              <i class="bi bi-list" aria-hidden="true"></i>
            </button>
          </div>

          <div class="topbar-right">
            <app-notification-bell></app-notification-bell>
            <div ngbDropdown class="dropdown user-dropdown" [autoClose]="true" placement="bottom-end">
              <div class="user-info-pill d-flex align-items-center gap-2 position-relative" ngbDropdownToggle
                   role="button">
                <div class="user-text text-end">
                  <p class="mb-0 fw-bold user-name">{{ userName }}</p>
                  @if (userRole) {
                    <p class="mb-0 user-type">{{ userRole }}</p>
                  }
                  @if (businessTypeSummary()) {
                    <p class="mb-0 user-type">{{ businessTypeSummary() }}</p>
                  }
                </div>
                <div class="user-avatar-wrap">
                  @if (userAvatar()) {
                    <img [src]="userAvatar()" [alt]="userName || 'รูปโปรไฟล์'" class="user-avatar-img" />
                  } @else {
                    <span class="user-avatar-placeholder">
                      <i class="bi bi-person-fill"></i>
                    </span>
                  }
                </div>
                <i class="bi bi-chevron-down chevron-down"></i>
              </div>

              <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end shadow border-0">
                <li class="dropdown-header px-3 py-2 border-bottom mb-1">
                  <div class="d-flex align-items-center gap-2">
                    <div class="user-avatar-wrap user-avatar-wrap-sm">
                      @if (userAvatar()) {
                        <img [src]="userAvatar()" [alt]="userName || 'รูปโปรไฟล์'" class="user-avatar-img" />
                      } @else {
                        <span class="user-avatar-placeholder">
                          <i class="bi bi-person-fill"></i>
                        </span>
                      }
                    </div>
                    <div class="overflow-hidden">
                      <div class="fw-bold text-dark text-truncate">{{ userName }}</div>
                      <div class="small text-muted text-truncate">{{ userEmail }}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <button ngbDropdownItem (click)="navigateToOidcAccountInfo()"
                          class="d-flex align-items-center gap-2">
                    <i class="bi bi-person-circle text-muted"></i>
                    <span>Account Info</span>
                  </button>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li>
                  <a ngbDropdownItem routerLink="/profile/role-assign" routerLinkActive="active"
                     class="d-flex align-items-center gap-2">
                    <i class="bi bi-shield-check text-muted"></i>
                    <span>มอบสิทธิ์ใช้งาน</span>
                  </a>
                </li>
                <li>
                  <a ngbDropdownItem routerLink="/profile/role-invitations" routerLinkActive="active"
                     class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-envelope-check text-muted"></i>
                      <span>ตอบรับคำเชิญ</span>
                    </div>
                    @if (pendingInvitationCount() > 0) {
                      <span class="badge rounded-pill bg-danger">{{ pendingInvitationCount() }}</span>
                    }
                  </a>
                </li>
                <li>
                  <hr class="dropdown-divider">
                </li>
                <li>
                  <button ngbDropdownItem (click)="logout()" class="d-flex align-items-center gap-2 text-danger">
                    <i class="bi bi-box-arrow-right"></i>
                    <span>Log out</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </header>
        <app-acting-as-banner></app-acting-as-banner>
      }

      @if (!fullScreenRoute()) {
        <app-breadcrumb></app-breadcrumb>
      }

      <main class="content-area" [class.mt-0]="!fullMainRoute()" [class.content-area-full-screen]="fullScreenRoute()"
            [class.content-area-full-main]="fullMainRoute()">
        <app-toasts></app-toasts>
        <app-loading></app-loading>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
}
